import { inject, injectable } from "inversify";
import * as THREE from "three";
import { DomElementsService, type IService, Logger } from "@designboticteam/core";

@injectable()
class CameraService implements IService {
	readonly serviceName = "🎥 CameraService";
	private logger = new Logger(`🎬 WORKSPACE 3D | ${this.serviceName}`, {
		color: "#ffffff",
		backgroundColor: "#0066cc",
	});

	#camera: THREE.PerspectiveCamera | null = null;
	public get camera() {
		if (!this.#camera) {
			throw new Error("Camera not initialized.");
		}

		return this.#camera;
	}

	constructor(@inject(DomElementsService) private domElementsService: DomElementsService) {
		this.logger.log("constructed");
	}

	public initialize(): void {
		const container = this.domElementsService.containerElement;
		this.#camera = new THREE.PerspectiveCamera(50, container.clientWidth / container.clientHeight, 0.1, 1000);
		this.#camera.position.set(50, 80, 50);

		this.logger.log("initialized");
	}

	public dispose() {
		this.#camera?.clear();
		this.#camera = null;
		this.logger.log("disposed");
	}
}

export { CameraService };
